export const en = {
  // Navigation
  navigation: {
    lessons: 'My Lessons',
    lessonLibrary: 'Lesson Library',
    tracking: 'Tracking',
    settings: 'Settings',
    dashboard: 'Dashboard',
    createLesson: 'Create Lesson',
    editLesson: 'Edit Lesson',
    back: 'Back',
    home: 'Home',
    schedule: 'Schedule',
    analytics: 'Analytics',
    more: 'More',
    admin: 'Admin',
    students: 'Students'
  },

  // Language
  language: {
    selectLanguage: 'Select Language',
    french: 'French',
    english: 'English'
  },

  // Common actions
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pause',
    resume: 'Resume',
    complete: 'Complete',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    refresh: 'Refresh',
    filter: 'Filter',
    search: 'Search',
    select: 'Select',
    create: 'Create',
    update: 'Update',
    loading: 'Loading...',
    saving: 'Saving...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information'
  },

  // Lesson metadata
  lesson: {
    title: 'Lesson Title',
    subject: 'Subject',
    domain: 'Discipline',
    construct: 'Competencies',
    subconstruct: 'Session Title',
    selectDomain: 'Select discipline',
    enterConstruct: 'Enter competencies',
    enterSubconstruct: 'Enter session title',
    globalMinimumProficiency: 'Global Minimum Proficiency',
    globalMinimumProficiencyPlaceholder: 'Enter global minimum proficiency',
    grade: 'Grade of Study',
    duration: 'Duration',
    objectives: 'Learning Objectives',
    prerequisites: 'Prerequisites',
    materials: 'Materials',
    timeline: 'Timeline',
    assessments: 'Assessments',
    resources: 'Resources',
    createNew: 'Create New Lesson',
    editLesson: 'Edit Lesson',
    lessonInformation: 'Lesson Information',
    enterLessonTitle: 'Enter lesson title',
    selectSubject: 'Select subject',
    className: 'Class Name',
    enterClassName: 'Enter class name (e.g., Math 101, Room 205)',
    selectGrade: 'Select grade of study',
    enterDuration: 'Enter duration in minutes',
    addObjective: 'Add learning objective',
    addPrerequisite: 'Add prerequisite',
    addMaterial: 'Add material',
    addResource: 'Add resource',
    addAssessment: 'Add assessment',
    addTimelineStep: 'Add timeline step',
    saveLesson: 'Save Lesson',
    lessonSaved: 'Lesson saved successfully',
    lessonDeleted: 'Lesson deleted successfully',
    lessonNotFound: 'Lesson not found',
    loadingLesson: 'Loading lesson...',
    noLessons: 'No lessons found',
    createFirstLesson: 'Create your first lesson',
    adminSettings: 'Admin Settings',
    markAsAdminLesson: 'Mark as Admin Lesson',
    adminLessonDescription: 'Admin lessons are available to all teachers in the lesson library and can be linked to their accounts.',
    importLessons: 'Import Lessons',
    uploadExcelFile: 'Upload Excel File',
    excelFileDescription: 'Upload an Excel file to import multiple lessons at once',
    importingLessons: 'Importing lessons...',
    importedSuccessfully: 'Successfully imported {count} lessons',
    minutes: 'minutes'
  },

  // Admin
  admin: {
    lessonManagement: 'Lesson Management',
    manageAllLessons: 'Manage all lessons in the system',
    createAdminLesson: 'Create Admin Lesson',
    totalLessons: 'Total Lessons',
    adminLessons: 'Admin Lessons',
    teacherLessons: 'Teacher Lessons',
    searchLessons: 'Search lessons...',
    allLessons: 'All Lessons',
    showingResults: 'Showing {count} of {total} lessons',
    loadingLessons: 'Loading lessons...',
    noLessonsFound: 'No lessons found',
    noLessonsMatchFilters: 'No lessons match your current filters',
    adminLesson: 'Admin Lesson',
    teacherLesson: 'Teacher Lesson',
    viewLesson: 'View Lesson',
    editLesson: 'Edit Lesson',
    deleteLesson: 'Delete Lesson',
    confirmDeleteLesson: 'Are you sure you want to delete this lesson? This action cannot be undone.',
    lessonDeleted: 'Lesson deleted successfully',
    deleteError: 'Error deleting lesson',
    accessDenied: 'Access Denied',
    adminPrivilegesRequired: 'Admin privileges are required to access this page.',
    lessonDuplicated: 'Lesson duplicated successfully',
    duplicateError: 'Error duplicating lesson',
    lessonMarkedAsAdmin: 'Lesson marked as admin',
    lessonUnmarkedAsAdmin: 'Lesson unmarked as admin',
    markAsAdmin: 'Mark as admin',
    unmarkAsAdmin: 'Unmark as admin',
    duplicateLesson: 'Duplicate lesson',
    oldest: 'Oldest first',
    bySubject: 'By subject'
  },

  // Students
  common: {
    cancel: 'Cancel',
    save: 'Save'
  },
  students: {
    management: 'Student Management',
    manageStudents: 'Manage your students and their relationships',
    addStudent: 'Add Student',
    editStudent: 'Edit Student',
    deleteStudent: 'Delete Student',
    totalStudents: 'Total Students',
    assignedToClass: 'Assigned to Class',
    activeStudents: 'Active Students',
    totalClasses: 'Total Classes',
    searchStudents: 'Search students...',
    allClasses: 'All Classes',
    allSchoolYears: 'All School Years',
    showingResults: 'Showing {count} of {total} students',
    loading: 'Loading students...',
    noStudentsFound: 'No students found',
    noStudentsMatchFilters: 'No students match your current filters',
    grade: 'Grade',
    class: 'Class',
    schoolYear: 'School Year',
    noGrade: 'No grade assigned',
    noClass: 'No class assigned',
    noSchoolYear: 'No school year assigned',
    name: 'Name',
    unknownClass: 'Unknown class',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      transferred: 'Transferred'
    },
    addSuccess: 'Student added successfully',
    addError: 'Error adding student',
    updateSuccess: 'Student updated successfully',
    updateError: 'Error updating student',
    deleteSuccess: 'Student deleted successfully',
    deleteError: 'Error deleting student',
    confirmDelete: 'Are you sure you want to delete this student? This action cannot be undone.',
    assignClassSuccess: 'Student assigned to class successfully',
    assignClassError: 'Error assigning student to class',
    removeClassSuccess: 'Student removed from class successfully',
    removeClassError: 'Error removing student from class',
    loadError: 'Error loading students',
    notes: 'Notes',
    statusText: 'Status',
    importStudents: 'Import Students',
    importInstructions: 'Upload a CSV file or paste CSV data below',
    csvData: 'CSV Data',
    preview: 'Preview',
    rows: 'rows',
    importFormat: 'Import Format',
    required: 'Required',
    optional: 'Optional',
    downloadTemplate: 'Download Template',
    importing: 'Importing...',
    importSuccess: 'Successfully imported {count} students',
    importError: 'Error importing students',
    importErrorNoData: 'No data provided for import',
    importErrorNoValidData: 'No valid student data found',
    importErrorNoStudentsImported: 'No students were imported',
    importErrorInvalidFormat: 'Invalid CSV format. Please ensure the file has a header row and at least one data row.',
    importErrorMissingNameColumn: 'CSV must contain a "Name" column. Please check your file format.',
    searchSchoolYear: 'Search school year...',
    searchClass: 'Search class...',
    saving: 'Saving...'
  },

  // Subjects
  subjects: {
    all: 'All',
    subject: 'Subject',
    math: 'Mathematics',
    geometry: 'Geometry',
    algebra: 'Algebra',
    preNumericalActivities: 'Pre-numerical Activities',
    measurement: 'Measurement',
    topology: 'Topology',
    numeration: 'Numeration',
    operations: 'Operations',
    language: 'Language',
    reading: 'Reading',
    writing: 'Writing',
    science: 'Science',
    english: 'English',
    history: 'History',
    art: 'Art',
    music: 'Music',
    french: 'French',
    geography: 'Geography',
    physicalEducation: 'Physical Education',
    nationalLanguages: 'National Languages',
    other: 'Other',
  },

  // Grades
  grades: {
    k: 'Kindergarten',
    '1': '1st Grade',
    '2': '2nd Grade',
    '3': '3rd Grade',
    '4': '4th Grade',
    '5': '5th Grade',
    '6': '6th Grade',
    '7': '7th Grade',
    '8': '8th Grade',
    '9': '9th Grade',
    '10': '10th Grade',
    '11': '11th Grade',
    '12': '12th Grade'
  },

  domains: {
    mathematics: 'Mathematics',
    french: 'French',
    nationalLanguagesMathematics: 'National Languages Mathematics',
    nationalLanguagesReadingWriting: 'National Languages Reading-Writing'
  },

  // Resource types
  resources: {
    numberLine: 'Number Line',
    tenFrame: 'Ten Frame',
    countObjects: 'Count Objects',
    matchingObjects: 'Matching Objects',
    timer: 'Timer',
    quiz: 'Quick Quiz',
    interactiveDiagram: 'Interactive Diagram',
    simulation: 'Simulation',
    flashcardSet: 'Flashcard Set',
    gridActivity: 'Grid Activity',
    audioBank: 'Audio Bank',
    assessment: 'Assessment',
    activity: 'Activity',
    feedback: 'Feedback',
    display: 'Display',
    manipulative: 'Manipulative'
  },

  // Resource configuration
  resourceConfig: {
    // Number Line
    minimumValue: 'Minimum Value',
    maximumValue: 'Maximum Value',
    tickEvery: 'Tick Every',
    step: 'Step',
    theme: 'Theme',
    primary: 'Primary',
    secondary: 'Secondary',
    showLabels: 'Show Labels',
    showNumberLabels: 'Show number labels',
    showTicks: 'Show Ticks',
    showTickMarks: 'Show tick marks',
    interactive: 'Interactive',
    allowUserInteraction: 'Allow user interaction',

    // Ten Frame
    rows: 'Rows',
    columns: 'Columns',
    doubleFrame: 'Double Frame',
    showTwoFrames: 'Show two frames',
    dragCounters: 'Drag Counters',
    allowDraggingCounters: 'Allow dragging counters',

    // Count Objects
    maxObjects: 'Max Objects',
    randomizeObjects: 'Randomize Objects',
    randomizeObjectPositions: 'Randomize object positions',
    touchFeedback: 'Touch Feedback',
    ping: 'Ping',
    pulse: 'Pulse',
    bounce: 'Bounce',
    shake: 'Shake',
    none: 'None',
    objectGroups: 'Object Groups',
    objectGroup: 'Object Group',
    objectType: 'Object Type',
    objectCount: 'Object Count',
    objectColor: 'Object Color',
    circle: 'Circle',
    square: 'Square',
    triangle: 'Triangle',
    star: 'Star',
    blue: 'Blue',
    red: 'Red',
    green: 'Green',
    yellow: 'Yellow',
    purple: 'Purple',
    orange: 'Orange',
    addObjectGroup: 'Add Object Group',
    remove: 'Remove',
    question: 'Question',
    questionPlaceholder: 'Enter a question for students...',
    showCount: 'Show Count',
    showObjectCount: 'Show object count',
    allowInteraction: 'Allow Interaction',
    allowObjectInteraction: 'Allow object interaction',

    // Matching Objects
    numberOfItems: 'Number of Items',
    howManyUniqueNumbers: 'How many unique numbers to match',
    representationTypes: 'Representation Types',
    includeObjects: 'Include Objects',
    includeNumerals: 'Include Numerals',
    includeTenFrames: 'Include Ten Frames',
    includeNumberWords: 'Include Number Words',
    selectAtLeastTwo: 'Select at least 2 representation types',
    objectLayout: 'Object Layout',
    howObjectsAreArranged: 'How objects are arranged visually',
    randomClustered: 'Random Clustered',
    linear: 'Linear',
    twoGroups: 'Two Groups',
    circular: 'Circular',
    preview: 'Preview',
    matchingActivityWith: 'Matching activity with',
    uniqueNumbersUpTo: 'unique numbers up to',
    includes: 'Includes',
    noRepresentationsSelected: 'No representations selected',

    // Timer
    duration: 'Duration',
    durationSeconds: 'Duration (seconds)',
    autoLaunch: 'Auto Launch',
    startTimerAutomatically: 'Start timer automatically',

    // Flashcard Set
    flashcards: 'Flashcards',
    front: 'Front',
    back: 'Back',
    answer: 'Answer',
    card: 'Card',
    addCard: 'Add Card',
    autoFlip: 'Auto Flip',
    autoFlipCards: 'Auto flip cards',
    showProgress: 'Show Progress',
    showCardProgress: 'Show card progress',
    autoAdvance: 'Auto Advance',
    autoAdvanceSeconds: 'Auto Advance (seconds)',
    autoAdvanceSecondsDescription: 'Seconds between auto-advance',
    shuffle: 'Shuffle',
    shuffleCards: 'Shuffle cards',
    quickSetup: 'Quick Setup',
    numbers0To10NumeralToWord: 'Numbers 0-10 (Numeral → Word)',
    numbers0To10WordToNumeral: 'Numbers 0-10 (Word → Numeral)',

    // Grid Activity
    bank: 'Bank',
    bankCommaSeparated: 'Bank (comma-separated)',
    mode: 'Mode',
    readAndSelect: 'Read and Select',
    matchPairs: 'Match Pairs',
    fillBlanks: 'Fill Blanks',

    // Audio Bank
    words: 'Words',
    wordsCommaSeparated: 'Words (comma-separated)',
    autoPlay: 'Auto Play',
    playAudioAutomatically: 'Play audio automatically',
    loop: 'Loop',
    loopAudio: 'Loop audio',

    // Simulation
    simulationTitle: 'Simulation Title',
    virtualLabSimulation: 'Virtual Lab Simulation',
    enterSimulationTitle: 'Enter simulation title',
    description: 'Description',
    enterSimulationDescription: 'Enter simulation description',

    // Interactive Diagram
    diagramTitle: 'Diagram Title',
    interactiveDiagram: 'Interactive Diagram',
    enterDiagramTitle: 'Enter diagram title',
    numberOfStages: 'Number of Stages',
    stage: 'Stage',
    stageDescription: 'Stage description',
    detailedInformationAboutStage: 'Detailed information about stage',

    // Time Sequence
    timeSequence: 'Time Sequence',
    events: 'Events',
    event: 'Event',
    time: 'Time',
    activity: 'Activity',
    period: 'Period',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    night: 'Night',
    addEvent: 'Add Event',
    removeEvent: 'Remove Event',
    showTime: 'Show Time',
    showPeriod: 'Show Period',
    allowReordering: 'Allow Reordering',
    dragToReorder: 'Drag to reorder events',
    sequenceEvents: 'Sequence events in chronological order',
    timeSequenceInstructions: 'Arrange the daily activities in the correct time order',

    // Measurement
    measurement: 'Measurement',
    objects: 'Objects',
    object: 'Object',
    units: 'Units',
    unit: 'Unit',
    length: 'Length',
    size: 'Size',
    shape: 'Shape',
    color: 'Color',
    addObject: 'Add Object',
    addUnit: 'Add Unit',
    removeObject: 'Remove Object',
    removeUnit: 'Remove Unit',
    objectName: 'Object Name',
    unitName: 'Unit Name',
    objectLength: 'Object Length',
    unitSize: 'Unit Size',
    showAnswers: 'Show Answers',
    measure: 'Measure',
    reset: 'Reset',
    readyToMeasure: 'Ready to measure',
    with: 'with',
    selectObjectAndUnit: 'Select an object and unit to begin',
    measurementResults: 'Measurement Results',
    measurementInstructions: 'Observe the objects and their measurements. Compare lengths and identify the units used.',

    // Modal
    noConfigOptions: 'No configuration options available for this resource type.',
    overrideSettings: 'Override Settings',
    overrideDescription: 'These settings will override the default resource configuration for this step only.',
    objectsCount: 'Objects Count',
    layout: 'Layout',
    randomize: 'Randomize',
    minValue: 'Min Value',
    maxValue: 'Max Value',
    cols: 'Cols',
    seconds: 'Seconds',
    id: 'ID',

    // Memory Game Configuration
    gameTitle: 'Game Title',
    memoryGame: 'Memory Game',
    enterGameTitle: 'Enter game title',
    gameDescription: 'Game Description',
    enterGameDescription: 'Enter game description',
    gameItems: 'Game Items',
    emoji: 'Emoji',
    word: 'Word',
    enterWord: 'Enter word',
    addItem: 'Add Item',
    removeItem: 'Remove Item',
    gameSettings: 'Game Settings',
    autoStartGame: 'Auto start game',
    showHints: 'Show hints',
    soundEffects: 'Sound effects',
    difficultyLevel: 'Difficulty Level',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',

    // Sorting Game Configuration
    categories: 'Categories',
    categoryName: 'Category Name',
    enterCategoryName: 'Enter category name',
    addCategory: 'Add Category',
    removeCategory: 'Remove Category',
    category: 'Category'
  },

  timeSequence: {
    description: 'Description',
    tip: 'Tip',
    tipDescription: 'You can drag the events to reorder them in chronological order.',
    defaultQuestion: 'Arrange the daily activities in chronological order',
    wakeUp: 'Wake up',
    breakfast: 'Have breakfast',
    goToSchool: 'Go to school',
    lunch: 'Have lunch',
    returnFromSchool: 'Return from school',
    goToBed: 'Go to bed',
    activityTakesPlace: 'This activity takes place',
    inTheMorning: 'in the morning',
    inTheAfternoon: 'in the afternoon',
    inTheEvening: 'in the evening',
    atNight: 'at night',
    at: 'at',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    night: 'Night',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },

  measurement: {
    defaultQuestion: 'Measure the objects with the appropriate units',
    objectMeasurement: 'Object Measurement',
    measureObjectsWithNonStandardUnits: 'Measure objects with non-standard units',
    objectsToMeasure: 'Objects to Measure',
    measurementUnits: 'Measurement Units',
    pencil: 'Pencil',
    eraser: 'Eraser',
    pen: 'Pen',
    paperclips: 'Paperclips',
    cubes: 'Cubes',
    books: 'Books',
    measurementResults: 'Measurement Results',
    selectObjectAndUnit: 'Select an object and unit to begin',
    length: 'Length',
    size: 'Size',
    shape: 'Shape',
    color: 'Color',
    showAnswers: 'Show Answers',
    measure: 'Measure',
    reset: 'Reset',
    readyToMeasure: 'Ready to measure',
    with: 'with',
    unit: 'Unit',
    correct: 'Correct',
    incorrect: 'Incorrect',
    actualLength: 'Actual Length',
    measurement: 'Measurement',
    expected: 'Expected',
    status: 'Status',
    tip: 'Tip',
    measurementTip: 'Compare your measurements with the expected values to check your understanding.',
  },

  currency: {
    defaultQuestion: 'Create the target amount using the available currency units',
    currencyCombination: 'Currency Combination',
    createAmountWithCurrency: 'Create amounts using different currency units',
    targetAmount: 'Target Amount',
    useCurrencyUnits: 'Use currency units to reach the target',
    availableUnits: 'Available Units',
    currentTotal: 'Current Total',
    checkAnswer: 'Check Answer',
    reset: 'Reset',
    correct: 'Correct!',
    incorrect: 'Incorrect',
    correctMessage: 'Perfect! You have created exactly {amount}',
    incorrectMessage: 'Your total is {current}, but the target is {target}',
    yourCombination: 'Your Combination',
    instructions: 'Instructions',
    instructionsDescription: 'Click on currency units to add them to your combination. Use the + and - buttons to adjust quantities.',
    coin1: '1€ Coin',
    coin2: '2€ Coin',
    bill5: '5€ Bill',
    bill10: '10€ Bill',
    newTarget: 'New Target',
    question: 'Question',
    questionPlaceholder: 'Enter a question for students...',
    showTarget: 'Show Target',
    allowInteraction: 'Allow Interaction',
    theme: 'Theme',
    primary: 'Primary',
    secondary: 'Secondary',
    success: 'Success',
    warning: 'Warning',
    newUnit: 'New Unit',
    currencyUnits: 'Currency Units',
    unit: 'Unit',
    name: 'Name',
    value: 'Value',
    symbol: 'Symbol',
    icon: 'Icon',
    color: 'Color',
    displayOptions: 'Display Options',
    changeTarget: 'Change Target',
    minTarget: 'Min Target',
    maxTarget: 'Max Target',
    coins: 'Coins',
    bills: 'Bills',
    euro: 'Euro',
    yellow: 'Yellow',
    green: 'Green',
    blue: 'Blue',
    red: 'Red',
    purple: 'Purple',
    gray: 'Gray',
    addUnit: 'Add Unit',
  },

  schedule: {
    scheduleManagement: 'Schedule Management',
    manageLessonSchedules: 'Manage lesson schedules and recurring sessions',
    calendar: 'Calendar',
    list: 'List',
    createSchedule: 'Create Schedule',
    editSchedule: 'Edit Schedule',
    scheduleDetails: 'Schedule Details',
    week: 'Week',
    month: 'Month',
    today: 'Today',
    untitled: 'Untitled',
    more: 'more',
    start: 'Start',
    complete: 'Complete',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    update: 'Update',
    export: 'Export',
    refresh: 'Refresh',
    searchSchedules: 'Search schedules...',
    allSchedules: 'All Schedules',
    activeSchedules: 'Active Schedules',
    inactiveSchedules: 'Inactive Schedules',
    scheduleList: 'Schedule List',
    loading: 'Loading...',
    noSchedulesFound: 'No schedules found',
    noSchedulesCreated: 'No schedules created yet',
    confirmDelete: 'Are you sure you want to delete this schedule?',
    title: 'Title',
    enterTitle: 'Enter schedule title',
    lesson: 'Lesson',
    selectLesson: 'Select a lesson',
    searchLessons: 'Search lessons...',
    noLessonsFound: 'No lessons found matching your search',
    untitledLesson: 'Untitled Lesson',
    class: 'Class',
    selectClass: 'Select a class',
    createNewClass: 'Create New Class',
    enterClassName: 'Enter class name (e.g., Math 101, Room 205)',
    className: 'Class Name',
    grade: 'Grade of Study',
    selectGrade: 'Select grade of study',
    enterClassDescription: 'Enter class description',
    description: 'Description',
    enterDescription: 'Enter schedule description',
    startDate: 'Start Date',
    startTime: 'Start Time',
    duration: 'Duration',
    endDate: 'End Date',
    optional: 'Optional',
    recurrenceTitle: 'Recurrence',
    recurrenceType: 'Recurrence Type',
    noRecurrence: 'No Recurrence',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    interval: 'Interval',
    daysOfWeek: 'Days of Week',
    dayOfMonth: 'Day of Month',
    endAfterOccurrences: 'End After Occurrences',
    enterOccurrences: 'Enter number of occurrences',
    endAfterOccurrencesHelp: 'Leave empty to continue indefinitely or until end date',
    maxStudents: 'Max Students',
    location: 'Location',
    enterLocation: 'Enter location',
    notes: 'Notes',
    enterNotes: 'Enter notes',
    conflictsDetected: 'Conflicts Detected',
    unknownLesson: 'Unknown Lesson',
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    status: {
      scheduled: 'Scheduled',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },
    recurrence: {
      none: 'No Recurrence',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly'
    },
    active: 'Active',
    inactive: 'Inactive',
    noDescription: 'No description',
    create: 'Create',
    grade1: '1st grade',
    grade2: '2nd grade',
    grade3: '3rd grade',
    import: 'Import',
    importing: 'Importing...',
    importSuccess: '{count} schedules imported successfully',
    importError: 'Error importing schedules. Please check the file format.',
    importPreview: 'Import Preview',
    importPreviewDescription: 'Review {valid} valid and {invalid} invalid schedules before importing',
    validSchedules: 'Valid Schedules',
    invalidSchedules: 'Invalid Schedules',
    valid: 'Valid',
    invalid: 'Invalid',
    confirmImport: 'Confirm Import',
    validationError: 'Validation error',
    grade4: '4th grade',
    grade5: '5th grade',
    grade6: '6th grade',
    grade7: '7th grade',
    grade8: '8th grade',
    grade9: '9th grade',
    grade10: '10th grade',
    grade11: '11th grade',
    grade12: '12th grade',
    conflictMessage: 'Time conflict with existing schedule on {date}'
  },

  // Assessment Panel
  assessmentPanel: {
    // Stimulus Components
    countTheObjects: 'Count the Objects',
    howManyObjectsDoYouSee: 'How many objects do you see?',
    layout: 'Layout',
    tenFrame: 'Ten Frame',
    fiveFrame: 'Five Frame',
    twentyFrame: 'Twenty Frame',
    customFrame: 'Frame',
    howManyDotsInTenFrame: 'How many dots are in the ten frame?',
    howManyDotsInFiveFrame: 'How many dots are in the five frame?',
    howManyDotsInTwentyFrame: 'How many dots are in the twenty frame?',
    howManyDotsInCustomFrame: 'How many dots are in the frame?',
    howManyDotsInFrame: 'How many dots are in the frame?',
    frameShowingDots: 'frame showing dots',
    numberLine: 'Number Line',
    whatNumberIsMarked: 'What number is marked on the number line?',
    numberSequence: 'Number Sequence',
    chooseCorrectNumber: 'Choose the correct number',
    whatNumberComesBefore: 'What number comes before?',
    whatNumberComesAfter: 'What number comes after?',
    whatNumberComesBetween: 'What number comes between?',
    numberComposition: 'Number Composition',
    writeNumberThatMatches: 'Write the number that matches the description',
    whatComesNextInSequence: 'What comes next in the sequence?',
    patternRecognition: 'Pattern Recognition',
    findPatternAndSelect: 'Find the pattern and select the missing piece',
    numberComparison: 'Number Comparison',
    compareNumbersAndSelect: 'Compare the numbers and select the correct answer',
    resourceComponentNotImplemented: 'Resource component not implemented yet',
    enterYourAnswer: 'Enter your answer:',
    enterNumber: 'Enter number',
    assessment: 'Assessment',
    readyToTestKnowledge: 'Ready to test your knowledge?',
    assessmentDetails: 'Assessment Details:',
    totalQuestions: 'Total Questions:',
    pointsPerQuestion: 'Points per Question:',
    masteryThreshold: 'Mastery Threshold:',
    cancel: 'Cancel',
    startAssessment: 'Start Assessment',
    congratulations: 'Congratulations!',
    assessmentComplete: 'Assessment Complete',
    youHaveMastered: 'You have mastered this content!',
    keepPracticingToImprove: 'Keep practicing to improve your score.',
    correctAnswers: 'Correct Answers',
    score: 'Score',
    timeSpent: 'Time Spent',
    status: 'Status',
    mastered: 'Mastered',
    inProgress: 'In Progress',
    close: 'Close',
    previous: 'Previous',
    next: 'Next',
    
    // Missing keys
    questionType: 'Question Type',
    numberLineFrom: 'Number line from'
  },

  // Authentication
  auth: {
    appName: 'Education App',
    tagline: 'Empowering teachers with digital tools',
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to continue to your dashboard',
    createAccount: 'Create Account',
    joinOurCommunity: 'Join our community of educators',
    email: 'Email',
    enterEmail: 'Enter your email',
    password: 'Password',
    enterPassword: 'Enter your password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    enterFullName: 'Enter your full name',
    school: 'School',
    enterSchool: 'Enter your school name',
    subjects: 'Subjects',
    grades: 'Grades',
    optional: 'Optional',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signingIn: 'Signing In...',
    creatingAccount: 'Creating Account...',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    signOut: 'Sign Out',
    profile: 'Profile',
    updateProfile: 'Update Profile'
  },

  // Assessment
  assessment: {
    title: 'Assessment',
    assessmentTitle: 'Assessment Title',
    studentAssessment: 'Student Assessment',
    enterAssessmentTitle: 'Enter assessment title',
    instructions: 'Instructions',
    enterAssessmentInstructions: 'Enter assessment instructions',
    selectAssessmentResource: 'Select Assessment Resource',
    selectAnAssessmentResource: 'Select an assessment resource...',
    timeLimit: 'Time Limit',
    timeLimitMinutes: 'Time Limit (minutes)',
    autoStart: 'Auto Start',
    startAssessmentAutomatically: 'Start assessment automatically',
    startAssessment: 'Start Assessment',
    completeAssessment: 'Complete Assessment',
    resourceType: 'Resource Type',
    noneSelected: 'None selected',
    timeRemaining: 'Time remaining',
    minutesRemaining: 'minutes remaining',
    assessmentCompleted: 'Assessment completed',
    assessmentInProgress: 'Assessment in progress',
    noAssessmentResources: 'No assessment resources available',
    createAssessmentResources: 'Create assessment-compatible resources first in the Resources tab'
  },

  // Lesson session
  session: {
    totalTime: 'Total Time',
    stepTime: 'Step Time',
    progress: 'Progress',
    currentStep: 'Current Step',
    nextStep: 'Next Step',
    previousStep: 'Previous Step',
    play: 'Play',
    pause: 'Pause',
    stop: 'Stop',
    reset: 'Reset',
    resources: 'Resources',
    noResourcesAvailable: 'No resources available for this step',
    expandResourcesPanel: 'Expand Resources Panel',
    closeResourcesPanel: 'Close Resources Panel',
    scrollToTop: 'Scroll to top',
    activeSession: 'Active Session'
  },

  // Tracking
  tracking: {
    dashboard: 'Tracking Dashboard',
    monitorStudentEngagement: 'Monitor student engagement and learning analytics',
    filters: 'Filters',
    refreshData: 'Refresh data',
    student: 'Student',
    lesson: 'Lesson',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    score: 'Score',
    attempts: 'Attempts',
    completed: 'Completed',
    incomplete: 'Incomplete',
    allStudents: 'All Students',
    allLessons: 'All Lessons',
    allDates: 'All Dates',
    lastActivity: 'Last Activity',
    totalEvents: 'Total Events',
    averageScore: 'Average Score',
    completionRate: 'Completion Rate',
    engagementScore: 'Engagement Score',
    timeSpent: 'Time Spent',
    lessonSummary: 'Lesson Summary',
    studentProgress: 'Student Progress',
    eventDetails: 'Event Details',
    noDataAvailable: 'No data available',
    noEventsFound: 'No events found',
    exportData: 'Export Data',
    downloadCSV: 'Download CSV',
    downloadJSON: 'Download JSON'
  },

  // Matching Objects Component
  matchingObjects: {
    title: 'Match the Representations',
    matchTheRepresentations: 'Match the Representations',
    generateNewItems: 'Generate new items',
    allMatchesFound: 'All matches found!',
    attempts: 'Attempts',
    matches: 'Matches',
    total: 'Total',
    clickAnotherItem: 'Click another item to match with the selected one',
    objects: 'Objects',
    numerals: 'Numerals',
    tenFrames: 'Ten Frames',
    words: 'Words',
    numberWords: {
      one: 'one',
      two: 'two',
      three: 'three',
      four: 'four',
      five: 'five',
      six: 'six',
      seven: 'seven',
      eight: 'eight',
      nine: 'nine',
      ten: 'ten'
    }
  },

  // Form validation
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    minLength: 'Must contain at least {min} characters',
    maxLength: 'Cannot exceed {max} characters',
    minValue: 'Value must be at least {min}',
    maxValue: 'Value cannot exceed {max}',
    invalidFormat: 'Invalid format',
    selectAtLeastOne: 'Select at least one item',
    selectAtLeastTwo: 'Select at least two items'
  },

  // Error messages
  errors: {
    general: 'An error occurred',
    networkError: 'Network error',
    serverError: 'Server error',
    notFound: 'Not found',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    validationError: 'Validation error',
    fileUploadError: 'File upload error',
    saveError: 'Save error',
    loadError: 'Load error',
    deleteError: 'Delete error',
    importError: 'Import error',
    exportError: 'Export error'
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    created: 'Created successfully',
    updated: 'Updated successfully',
    imported: 'Imported successfully',
    exported: 'Exported successfully',
    uploaded: 'Uploaded successfully'
  },

  // Placeholders
  placeholders: {
    enterTitle: 'Enter title',
    enterDescription: 'Enter description',
    enterName: 'Enter name',
    enterValue: 'Enter value',
    selectOption: 'Select an option',
    searchHere: 'Search here',
    noResults: 'No results',
    loading: 'Loading...',
    saving: 'Saving...',
    processing: 'Processing...'
  },

  // Time formatting
  time: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    ago: 'ago',
    justNow: 'just now',
    lessThanMinute: 'less than a minute',
    aboutMinute: 'about a minute',
    minutesAgo: 'minutes',
    aboutHour: 'about an hour',
    hoursAgo: 'hours',
    aboutDay: 'about a day',
    daysAgo: 'days'
  },

  // Numbers
  numbers: {
    zero: 'zero',
    one: 'one',
    two: 'two',
    three: 'three',
    four: 'four',
    five: 'five',
    six: 'six',
    seven: 'seven',
    eight: 'eight',
    nine: 'nine',
    ten: 'ten'
  },

  // Dashboard
  dashboard: {
    welcomeBack: 'Welcome back, Teacher!',
    readyToInspire: 'Ready to inspire your students today? You have {count} lessons available.',
    totalLessons: 'Total Lessons',
    completedSessions: 'Completed Sessions',
    totalStudents: 'Total Students',
    averageRating: 'Average Rating',
    thisMonth: 'this month',
    thisWeek: 'this week',
    quickActions: 'Quick Actions',
    browseLessons: 'Browse Lessons',
    findNextLesson: 'Find your next lesson',
    startSession: 'Start Session',
    beginTeaching: 'Begin teaching now',
    viewSchedule: 'View Schedule',
    checkCalendar: 'Check your calendar',
    analytics: 'Analytics',
    viewProgress: 'View your progress',
    recentLessons: 'Recent Lessons',
    viewAll: 'View all',
    noLessonsYet: 'No lessons available yet.',
    createFirstLesson: 'Create your first lesson'
  },

  // Lesson Library
  lessonLibrary: {
    title: 'Lesson Library',
    description: 'Browse and link admin-created lessons to your account',
    searchLessons: 'Search lessons...',
    loading: 'Loading lessons...',
    results: '{count} lessons found',
    noLessons: 'No lessons found',
    noLessonsDescription: 'No admin lessons match your current filters.',
    linkLesson: 'Link Lesson',
    alreadyLinked: 'Already Linked',
    linkSuccess: 'Lesson linked successfully!',
    linkError: 'Failed to link lesson',
    fetchError: 'Failed to fetch lessons',
    loginRequired: 'Please log in to link lessons'
  },

  // Lesson List
  lessonList: {
    lessons: 'Lessons',
    browseAndManage: 'Browse and manage your lesson plans',
    createLesson: 'Create Lesson',
    searchLessons: 'Search lessons...',
    all: 'All',
    mostRecent: 'Most Recent',
    titleAZ: 'Title A-Z',
    duration: 'Duration',
    lessonFound: 'lesson found',
    lessonsFound: 'lessons found',
    min: 'min',
    steps: 'steps',
    students: 'students',
    deleteLesson: 'Delete lesson',
    viewTrackingData: 'View tracking data',
    edit: 'Edit',
    start: 'Start',
    deleteConfirm: 'Are you sure you want to delete "{title}"? This action cannot be undone.',
    lessonDeleted: 'Lesson deleted successfully',
    deleteFailed: 'Failed to delete lesson',
    noDescription: 'No description available',
    noLessonsFound: 'No lessons found',
    adjustSearchCriteria: 'Try adjusting your search criteria',
    getStartedCreating: 'Get started by creating your first lesson',
    createYourFirstLesson: 'Create Your First Lesson'
  },

  // Header
  header: {
    appTitle: 'TeacherApp',
    searchLessons: 'Search lessons...',
    teacherName: 'Teacher Name'
  },

  // Learning Objectives
  learningObjectives: {
    learningObjectives: 'Specific Learning Objectives',
    addObjective: 'Add Specific Learning Objective',
    objective: 'Specific Learning Objective',
    successCriteria: 'Success Criteria',
    addSuccessCriteria: 'Add Success Criteria',
    successCriteriaItem: 'Success criteria',
    standardsAlignment: 'Standards Alignment',
    addStandard: 'Add Standard',
    standard: 'Standard',
    standardPlaceholder: 'Standard {index} (e.g., CCSS.MATH.CONTENT.1.NBT.A.1)'
  },

  // Materials
  materials: {
    materialsAndResources: 'Materials & Resources',
    digitalMaterials: 'Digital Materials',
    physicalMaterials: 'Physical Materials',
    addDigitalMaterial: 'Add Digital Material',
    addPhysicalMaterial: 'Add Physical Material',
    digitalMaterial: 'Digital material',
    physicalMaterial: 'Physical material'
  },

  // Timer
  timer: {
    timer: 'Timer'
  },

  // Image Component
  image: {
    image: 'Image',
    noImageUrl: 'No image URL provided',
    provideImageUrl: 'Please provide an image URL in the resource configuration',
    loadError: 'Failed to load image'
  },

  // Image Configuration Form
  imageConfig: {
    uploadImage: 'Upload Image',
    selectFile: 'Select Image File',
    uploading: 'Uploading...',
    uploadHint: 'Upload an image file (JPEG, PNG, GIF, WebP, SVG). Max size: 5MB',
    or: 'OR',
    imageUrl: 'Image URL',
    urlHint: 'Enter a direct URL to an image',
    altText: 'Alt Text',
    altTextPlaceholder: 'Description of the image',
    altTextHint: 'Alternative text for accessibility',
    caption: 'Caption',
    captionPlaceholder: 'Optional caption to display below the image',
    alignment: 'Alignment',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    fitMode: 'Fit Mode',
    contain: 'Contain - Fit image within bounds',
    cover: 'Cover - Fill bounds, may crop',
    fill: 'Fill - Stretch to fill bounds',
    fitModeHint: 'How the image should fit within its container',
    width: 'Width',
    height: 'Height',
    preview: 'Preview',
    removeImage: 'Remove Image',
    invalidFileType: 'Invalid file type. Please select an image file (JPEG, PNG, GIF, WebP, SVG)',
    fileTooLarge: 'File is too large. Maximum size is 5MB',
    uploadError: 'Failed to upload image. Please try again.',
    invalidImageUrl: 'Invalid image URL or image failed to load',
    notAuthenticated: 'You must be signed in to upload images. Please sign in and try again.',
    authenticationRequired: 'Authentication Required',
    authenticationHint: 'You must be signed in to upload images. Please sign in to your account first.',
    corsError: 'CORS error: Please check your Firebase Storage configuration. Make sure CORS rules are properly configured and you are authenticated.',
    permissionError: 'Permission denied (403). Please check your Firebase Storage security rules. Make sure authenticated users can write to the "images/" folder.',
    checkDocumentation: 'See docs/FIREBASE_STORAGE_SETUP.md for detailed configuration instructions.'
  },

  // Rich Text Component
  richText: {
    richText: 'Rich Text',
    noContent: 'No content provided',
    provideContent: 'Please provide content in the resource configuration'
  },

  // Rich Text Configuration Form
  richTextConfig: {
    title: 'Title',
    titlePlaceholder: 'Optional title for the content',
    titleHint: 'Optional title displayed above the content',
    content: 'Content',
    contentPlaceholder: 'Enter your text content here...',
    contentHint: 'Use the toolbar to format your text. Supports HTML formatting.',
    preview: 'Preview',
    alignment: 'Text Alignment',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    justify: 'Justify',
    fontSize: 'Font Size',
    inherit: 'Inherit (default)',
    backgroundColor: 'Background Color',
    textColor: 'Text Color',
    maxWidth: 'Max Width',
    maxWidthHint: 'Maximum width of the content (e.g., 800px, 100%, none)',
    padding: 'Padding',
    paddingHint: 'Padding around the content (e.g., 1rem, 16px, 1rem 2rem)'
  },

  // Tracking Dashboard
  trackingDashboard: {
    trackingDashboard: 'Tracking Dashboard',
    noActiveSession: 'No active lesson session for tracking.',
    lesson: 'Lesson',
    status: 'Status',
    active: 'Active',
    disabled: 'Disabled',
    refreshData: 'Refresh data',
    totalEvents: 'Total Events',
    totalTime: 'Total Time',
    students: 'Students',
    completionRate: 'Completion Rate',
    lessonSummary: 'Lesson Summary',
    averageTime: 'Average Time',
    minutes: 'minutes',
    averageScore: 'Average Score',
    engagementRate: 'Engagement Rate',
    lastActivity: 'Last Activity',
    recentEvents: 'Recent Events',
    noEventsRecorded: 'No events recorded yet.',
    exportData: 'Export Data',
    exporting: 'Exporting...',
    export: 'Export',
    clearData: 'Clear Data',
    clearDataConfirm: 'Are you sure you want to clear all tracking data for this lesson? This action cannot be undone.',
    student: 'Student',
    unknownTime: 'Unknown time',
    invalidTime: 'Invalid time'
  },

  // UI Component Selector
  uiComponentSelector: {
    selectUIComponentType: 'Select UI Component Type'
  },

  // Activity Component
  activityComponent: {
    interactiveActivity: 'Interactive Activity',
    mode: 'Mode',
    audio: 'Audio',
    enabled: 'Enabled',
    disabled: 'Disabled',
    startActivity: 'Start Activity',
    activityInProgress: 'Activity in progress...',
    score: 'Score',
    completeActivity: 'Complete Activity'
  },

  // Assessments Section
  assessmentsSection: {
    assessments: 'Assessments',
    addAssessment: 'Add Assessment',
    removeAssessment: 'Remove Assessment',
    addItem: 'Add Item',
    removeItem: 'Remove Item',
    assessmentItem: 'Assessment Item',
    type: 'Type',
    selectType: 'Select Type',
    quizResource: 'Quiz Resource',
    countObjects: 'Count Objects',
    tenFrameRead: 'Ten Frame Read',
    numberLinePoint: 'Number Line Point',
    beforeAfter: 'Before/After',
    composeNumbers: 'Compose Numbers',
    sequence: 'Sequence',
    pattern: 'Pattern',
    comparison: 'Comparison',
    multipleChoice: 'Multiple Choice',
    stimulus: 'Stimulus',
    enterPrompt: 'Enter prompt or question',
    choices: 'Choices',
    addChoice: 'Add Choice',
    choice: 'Choice',
    selectResource: 'Select Resource',
    noQuizResources: 'No quiz resources available',
    createQuizResources: 'Create quiz resources first',
    scoring: 'Scoring',
    pointsPerCorrect: 'Points per correct answer',
    maxScore: 'Maximum score',
    masteryThreshold: 'Mastery threshold',
    timeLimit: 'Time limit',
    minutes: 'minutes',
    autoStart: 'Auto start',
    configuration: 'Configuration',
    minValue: 'Minimum value',
    maxValue: 'Maximum value',
    numBefore: 'Number before',
    numAfter: 'Number after',
    showHint: 'Show hint',
    firstNumber: 'First Number',
    secondNumber: 'Second Number',
    baseNumber: 'Base Number',
    questionType: 'Question Type',
    before: 'Before',
    after: 'After',
    between: 'Between',
    answer: 'Answer',
    prompt: 'Prompt',
    enterQuestionPrompt: 'Enter question prompt',
    selectQuizResource: 'Select Quiz Resource',
    selectQuizResourcePlaceholder: 'Select a quiz resource...',
    noQuizResourcesAvailable: 'No quiz resources available. Create a quiz resource first in the Resources tab.',
    quizResourceDetails: 'Quiz Resource Details:',
    resourceId: 'Resource ID:',
    questions: 'Questions:',
    shuffle: 'Shuffle:',
    questionExamples: 'Question Examples:',
    question: 'Question',
    andMore: 'and {count} more',
    whatComesBefore: 'What comes before?',
    whatComesAfter: 'What comes after?',
    whatComesBetween: 'What comes between?',
    secondNumberForBetween: 'Second Number (for between)',
    objectCount: 'Object Count',
    layout: 'Layout',
    frameValue: 'Frame Value',
    numberLineRange: 'Number Line Range',
    markedPosition: 'Marked Position',
    yes: 'Yes',
    no: 'No',
    answerChoices: 'Answer Choices',
    addQuestion: 'Add Question',
    addResource: 'Add Resource',
    includeResource: 'Include Interactive Resource',
    addInteractiveComponent: 'Add interactive component (e.g., count objects)',
    quickAdd: 'Quick Add',
    addNewQuestion: 'Add New Question',
    questionPrompt: 'Question Prompt',
    correctAnswer: 'Correct Answer',
    enterCorrectAnswer: 'Enter correct answer',
    enterChoices: 'Enter choices (comma-separated)',
    correctAnswerMustBeOneOfTheChoices: 'Correct answer must be one of the choices',
    rows: 'Rows',
    columns: 'Columns',
    howManyObjectsDoYouSee: 'How many objects do you see?',
    whatNumberComesAfter9: 'What number comes after 9?',
    whatIs5Plus3: 'What is 5 + 3?',
    removeChoice: 'Remove Choice',
    answerNotInChoices: 'Answer not in choices!',
    interactiveResource: 'Interactive Resource',
    resourceType: 'Resource Type',
    objectsCount: 'Objects Count',
    randomClustered: 'Random Clustered',
    twoGroups: 'Two Groups',
    linear: 'Linear',
    randomize: 'Randomize',
    randomizeObjectPositions: 'Randomize object positions',
    tickEvery: 'Tick Every',
    markPosition: 'Mark Position',
    bank: 'Bank (comma-separated numbers)',
    bankPlaceholder: '0, 1, 2, 3, 4, 5',
    mode: 'Mode',
    readAndSelect: 'Read and Select',
    dragAndDrop: 'Drag and Drop',
    clickToFill: 'Click to Fill',
    autoFlip: 'Auto Flip',
    cards: 'Cards (comma-separated)',
    cardsPlaceholder: 'A, B, C, D, E',
    autoFlipCards: 'Auto flip cards',
    
    // Number Line Stimulus Advanced Options
    markStyle: 'Mark Style',
    colorTheme: 'Color Theme',
    showRangeLabels: 'Show range labels (start-end)',
    showStepInfo: 'Show step information',
    advancedOptions: 'Advanced Options',
    points: 'Points',
    autoAdvanceSeconds: 'Auto Advance Seconds',
    showProgress: 'Show Progress',
    autoAdvance: 'Auto Advance'
  },

  // Data and Reporting Section
  dataAndReporting: {
    dataAndReporting: 'Data and Reporting',
    trackingEvents: 'Tracking Events',
    addEvent: 'Add Event',
    addPresetEvent: 'Add Preset Event',
    removeEvent: 'Remove Event',
    eventName: 'Event Name',
    when: 'When',
    capture: 'Capture',
    description: 'Description',
    enterEventName: 'Enter event name',
    selectTrigger: 'Select trigger',
    enterDescription: 'Enter description',
    addDataPoint: 'Add Data Point',
    dataPoint: 'Data Point',
    groupingRules: 'Grouping Rules',
    addRule: 'Add Rule',
    addPresetRule: 'Add Preset Rule',
    removeRule: 'Remove Rule',
    rule: 'Rule',
    enterRule: 'Enter grouping rule',
    reportingSettings: 'Reporting Settings',
    frequency: 'Frequency',
    selectFrequency: 'Select frequency',
    realTime: 'Real-time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    format: 'Format',
    selectFormat: 'Select format',
    dashboard: 'Dashboard',
    exportOptions: 'Export Options',
    csv: 'CSV',
    json: 'JSON',
    pdf: 'PDF',
    enableAutoExport: 'Enable auto-export',
    retentionDays: 'Retention days',
    privacySettings: 'Privacy Settings',
    anonymizeData: 'Anonymize data',
    enableEncryption: 'Enable encryption',
    requireConsent: 'Require consent',
    // Preset events
    assessmentCompletion: 'Assessment Completion',
    trackAssessmentPerformance: 'Track assessment completion and performance',
    stepCompletion: 'Step Completion',
    trackStepCompletion: 'Track timeline step completion',
    resourceInteraction: 'Resource Interaction',
    trackResourceInteractions: 'Track student interactions with resources',
    quizResponse: 'Quiz Response',
    trackQuizResponses: 'Track individual quiz question responses',
    engagementCheck: 'Engagement Check',
    trackEngagement: 'Track student engagement and participation',
    exitTicket: 'Exit Ticket',
    whenToCapture: 'When to Capture',
    dataToCapture: 'Data to Capture',
    addEventsToTrack: 'Add Events to Track',
    noDataEventsConfigured: 'No data events configured yet.',
    configureAnalytics: 'Configure Analytics',
    studentTrackingOptions: 'Student Tracking Options',
    trackExitTicketResponses: 'Track exit ticket responses',
    analyticsSettings: 'Analytics Settings',
    enableAnalytics: 'Enable Analytics',
    trackStudentPerformance: 'Track student performance and engagement',
    progressTracking: 'Progress Tracking',
    trackCompletionRates: 'Track completion rates',
    timeTracking: 'Time Tracking',
    monitorTimeSpent: 'Monitor time spent',
    engagementMetrics: 'Engagement Metrics',
    trackInteractions: 'Track interactions',
    reportingConfiguration: 'Reporting Configuration',
    configureReporting: 'Configure how and when to generate reports',
    reportingFrequency: 'Reporting Frequency',
    endOfLesson: 'End of Lesson',
    exportFormats: 'Export Formats',
    spreadsheetFormat: 'Spreadsheet format',
    printableReports: 'Printable reports',
    dataExport: 'Data export',
    nextLessonGroupingRule: 'Next Lesson Grouping Rule',
    viewPresets: 'View Presets',
    quickAddPresetRules: 'Quick Add Preset Rules',
    nextLessonGroupingRulePlaceholder: 'e.g., If score < 70%, assign remedial practice; else assign enrichment activities.',
    nextLessonGroupingRuleDescription: 'Define rules for automatically grouping students for the next lesson based on their performance.',
    addField: 'Add Field',
    presetEvents: {
      assessment_complete: {
        description: 'Track assessment completion and performance'
      },
      step_complete: {
        description: 'Track timeline step completion'
      },
      exit_ticket_submit: {
        description: 'Track exit ticket submission'
      },
      resource_interaction: {
        description: 'Track student interactions with resources'
      },
      quiz_response: {
        description: 'Track individual quiz question responses'
      },
      engagement_check: {
        description: 'Track student engagement and participation'
      }
    },
    presetGroupingRules: {
      'score_below_70': 'If score < 70%, assign remedial practice; else assign enrichment activities.',
      'engagement_below_50': 'If engagement < 50%, provide additional support; else assign advanced work.',
      'time_spent_above_120': 'If time_spent > 120% of expected, assign simplified version; else assign standard version.',
      'correct_answers_below_3': 'If correct_answers < 3, assign \'Build Foundation\' practice; else assign \'Extend Learning\' practice.',
      'participation_below_2': 'If participation < 2 interactions, assign guided practice; else assign independent practice.'
    },
    configureDataCollectionEvents: 'Configure when and what data to capture during lessons',
    dataCollectionEvents: 'Data Collection Events',
    presets: 'Presets',
    addCustom: 'Add Custom',
    quickAddPresetEvents: 'Quick Add Preset Events',
    event: 'Event',
    briefDescriptionOfThisEvent: 'Brief description of this event',
    captures: 'Captures'
  },

  // Differentiation Section
  differentiation: {
    differentiation: 'Differentiation',
    configureStrategies: 'Configure strategies to meet all student needs',
    supports: 'Supports',
    extensions: 'Extensions',
    ellSupport: 'ELL Support',
    supportDiverseLearners: 'Support diverse learners with targeted strategies',
    supportsForStrugglingLearners: 'Supports for Struggling Learners',
    strategiesForAdditionalSupport: 'Strategies to help students who need additional support',
    presets: 'Presets',
    addCustom: 'Add Custom',
    quickAddPresetStrategies: 'Quick Add Preset Strategies',
    describeSupportStrategy: 'Describe the support strategy...',
    noSupportStrategies: 'No support strategies configured yet.',
    addStrategiesToHelp: 'Add strategies to help struggling learners succeed.',
    extensionsForAdvancedLearners: 'Extensions for Advanced Learners',
    challengeActivitiesForStudents: 'Challenge activities for students who need more rigor',
    quickAddPresetExtensions: 'Quick Add Preset Extensions',
    describeExtensionActivity: 'Describe the extension activity...',
    noExtensionActivities: 'No extension activities configured yet.',
    addChallengingActivities: 'Add challenging activities for advanced learners.',
    ellSupportFull: 'English Language Learner (ELL) Support',
    languageScaffolding: 'Language scaffolding and visual supports for ELL students',
    sentenceFrames: 'Sentence Frames',
    provideLanguageStructures: 'Provide language structures for students to express their thinking',
    quickAddSentenceFrames: 'Quick Add Sentence Frames',
    sentenceFrameExample: 'e.g., I think ___ because ___.',
    noSentenceFrames: 'No sentence frames configured yet.',
    addLanguageStructures: 'Add language structures to support ELL students.',
    visualIcons: 'Visual Icons',
    nonVerbalCues: 'Non-verbal cues and visual supports for communication',
    quickAddVisualIcons: 'Quick Add Visual Icons',
    visualIconExample: 'e.g., touch, say, move, count',
    noVisualIcons: 'No visual icons configured yet.',
    addNonVerbalCues: 'Add non-verbal cues to support ELL students.',
    adaptiveScaffolding: 'Adaptive Scaffolding',
    multimodalSupport: 'Multimodal Support',
    personalizedPacing: 'Personalized Pacing',
    criteriaBasedGrouping: 'Criteria-Based Grouping',
    addScaffold: 'Add Scaffold',
    removeScaffold: 'Remove Scaffold',
    condition: 'Condition',
    action: 'Action',
    selectCondition: 'Select Condition',
    selectAction: 'Select Action',
    addSupport: 'Add Support',
    removeSupport: 'Remove Support',
    supportType: 'Support Type',
    selectSupportType: 'Select Support Type',
    addPacingRule: 'Add Pacing Rule',
    removePacingRule: 'Remove Pacing Rule',
    studentCriteria: 'Student Criteria',
    pacingAdjustment: 'Pacing Adjustment',
    addGroupingRule: 'Add Grouping Rule',
    removeGroupingRule: 'Remove Grouping Rule',
    groupingCriteria: 'Grouping Criteria',
    resultingGroup: 'Resulting Group'
  },

  // Differentiation Display
  differentiationDisplay: {
    differentiationStrategies: 'Differentiation Strategies',
    noStrategiesConfigured: 'No differentiation strategies have been configured for this lesson.',
    configureStrategiesInEditor: 'Configure strategies in the lesson editor to support diverse learners.',
    strategiesToSupportLearners: 'Strategies to support diverse learners',
    supportsForStrugglingLearners: 'Supports for Struggling Learners',
    extensionsForAdvancedLearners: 'Extensions for Advanced Learners',
    ellSupport: 'English Language Learner (ELL) Support',
    sentenceFrames: 'Sentence Frames',
    visualIcons: 'Visual Icons',
    useStrategiesToSupport: 'Use these strategies to support diverse learners during instruction',
    differentiationReady: 'Differentiation Ready'
  },

  // Import Export Section
  importExport: {
    importExport: 'Import/Export',
    importLesson: 'Import Lesson',
    exportLesson: 'Export Lesson',
    selectFile: 'Select File',
    chooseFile: 'Choose File',
    importButton: 'Import',
    lessonImported: 'Lesson imported successfully',
    importFailed: 'Failed to import lesson',
    invalidFile: 'Invalid file or unsupported format',
    exportAs: 'Export as',
    download: 'Download',
    exportFailed: 'Export failed',
    importDescription: 'Import a lesson from a JSON file',
    exportDescription: 'Download current lesson as JSON',
    sampleLesson: 'Sample Lesson',
    sampleLessonDescription: 'Download a sample lesson template',
    downloadSample: 'Download Sample',
    importExportInformation: 'Import/Export Information',
    importInfo1: 'Import lessons from JSON files to quickly load existing content',
    importInfo2: 'Export lessons to share with other teachers or backup your work',
    importInfo3: 'Download the sample lesson to see the complete lesson structure',
    importInfo4: 'All lesson data including resources, timeline, and assessments are included'
  },

  // Timeline Steps Section
  timelineSteps: {
    timelineSteps: 'Timeline Steps',
    addStep: 'Add Step',
    step: 'Step',
    removeStep: 'Remove Step',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    collapseStep: 'Collapse Step',
    expandStep: 'Expand Step',
    minutes: 'min',
    moveResourceUp: 'Move Resource Up',
    moveResourceDown: 'Move Resource Down',
    stepName: 'Step Name',
    enterStepName: 'Enter step name',
    duration: 'Duration',
    stepType: 'Step Type',
    warmUp: 'Warm-Up',
    launch: 'Launch',
    directInstruction: 'Direct Instruction',
    guidedPractice: 'Guided Practice',
    independentPractice: 'Independent Practice',
    closing: 'Closing',
    teacherScript: 'Teacher Script',
    addScript: 'Add Script',
    enterTeacherScript: 'Enter teacher script',
    scriptSegment: 'Script Segment',
    removeScript: 'Remove Script',
    studentActions: 'Student Actions',
    addAction: 'Add Action',
    enterStudentAction: 'Enter student action',
    checksForUnderstanding: 'Checks for Understanding',
    addCheck: 'Add Check',
    enterCheckForUnderstanding: 'Enter check for understanding',
    checkType: 'Check Type',
    observation: 'Observation',
    question: 'Question',
    quickPoll: 'Quick Poll',
    exitTicket: 'Exit Ticket',
    prompt: 'Prompt',
    lookFor: 'Look For',
    enterLookFor: 'Enter what to look for',
    commonError: 'Common Error',
    enterCommonError: 'Enter common error to avoid',
    
    // Resources
    resources: 'Resources',
    selectResource: 'Select Resource to attach',
    removeResource: 'Remove Resource',
    configureResource: 'Configure Resource',
    customConfig: 'Custom Config',
    noResourcesAttached: 'No resources attached to this step',
    noResourcesAvailable: 'No resources available. Create resources in the Resources tab first.'
  },

  // Flashcard Set Component
  flashcardSet: {
    flashcardSet: 'Flashcard Set',
    noItemsConfigured: 'No items configured',
    card: 'Card',
    of: 'of',
    next: 'Next',
    previous: 'Previous',
    flip: 'Flip',
    autoAdvance: 'Auto Advance',
    stopAutoAdvance: 'Stop Auto Advance'
  },

  // Memory Game Component
  memoryGame: {
    memoryGame: 'Memory Game',
    matchEmojiWithName: 'Match the emoji with its name',
    startGame: 'Start Game',
    resetGame: 'Reset Game',
    matchedPairs: 'Matched Pairs',
    status: 'Status',
    completed: 'Completed',
    inProgress: 'In Progress',
    congratulations: 'Congratulations!',
    gameCompletedMessage: 'You have completed the memory game!',
    noItemsConfigured: 'No items configured for the game',
    card: 'Card',
    of: 'of',
    flip: 'Flip',
    match: 'Match',
    noMatch: 'No Match'
  },


  // Feedback Component
  feedback: {
    feedback: 'Feedback',
    type: 'Type',
    showAnswers: 'Show Answers',
    yes: 'Yes',
    no: 'No',
    enterFeedback: 'Enter your feedback...',
    submitFeedback: 'Submit Feedback',
    thankYou: 'Thank you for your feedback!'
  },

  // Grid Activity Component
  gridActivity: {
    gridActivity: 'Grid Activity',
    mode: 'Mode',
    reset: 'Reset',
    clearSelection: 'Clear Selection',
    selected: 'Selected',
    cells: 'cells'
  },

  // Resource Selector
  resourceSelector: {
    resources: 'Resources',
    addResource: 'Add Resource',
    id: 'ID',
    configure: 'Configure',
    hideConfiguration: 'Hide Configuration'
  },

  // Resource Type Selector
  resourceTypeSelector: {
    selectResourceType: 'Select Resource Type'
  },

  // Resource Types
  resourceTypes: {
    numberLine: 'Number Line',
    numberLineDescription: 'Interactive number line for counting and number sense',
    tenFrame: 'Ten Frame',
    tenFrameDescription: 'Interactive ten frame for number representation',
    countObjects: 'Count Objects',
    countObjectsDescription: 'Interactive canvas for counting objects',
    matchingObjects: 'Matching Objects',
    matchingObjectsDescription: 'Match different representations of quantities',
    timer: 'Timer',
    timerDescription: 'Countdown timer for activities',
    quiz: 'Quick Quiz',
    quizDescription: 'Interactive assessment tool',
    sampleQuestion1: 'How many objects do you see?',
    sampleQuestion2: 'What number comes after 9?',
    image: 'Image',
    imageDescription: 'Display an image in the lesson',
    richText: 'Rich Text',
    richTextDescription: 'Display formatted text content with HTML support',
    interactiveDiagram: 'Interactive Diagram',
    interactiveDiagramDescription: 'Interactive diagram with clickable stages',
    stage1: 'Stage 1',
    stage1Description: 'First stage description',
    stage1Details: 'Detailed information about stage 1',
    stage2: 'Stage 2',
    stage2Description: 'Second stage description',
    stage2Details: 'Detailed information about stage 2',
    stage3: 'Stage 3',
    stage3Description: 'Third stage description',
    stage3Details: 'Detailed information about stage 3',
    simulation: 'Virtual Lab Simulation',
    simulationDescription: 'Interactive science experiment simulation',
    water: 'Water',
    waterDescription: 'Liquid water for the experiment',
    heat: 'Heat Source',
    heatDescription: 'Heat to evaporate water',
    condensationChamber: 'Condensation Chamber',
    condensationChamberDescription: 'Cool area for water to condense',
    simulationTitle: 'Mini Water Cycle Experiment',
    simulationDataDescription: 'Observe how water changes states through evaporation and condensation',
    initialSetup: 'Initial Setup',
    initialSetupDescription: 'Water at room temperature',
    readyToStart: 'Ready to start experiment',
    heatingPhase: 'Heating Phase',
    heatingPhaseDescription: 'Heat source warms the water',
    heatingWater: 'Heating water... Water beginning to evaporate',
    condensationPhase: 'Condensation Phase',
    condensationPhaseDescription: 'Water vapor cools and condenses',
    waterVaporCondensing: 'Water vapor condensing on cool surface',
    learningObjective1: 'Understand the three states of water (solid, liquid, gas)',
    learningObjective2: 'Observe the process of evaporation',
    learningObjective3: 'See how condensation forms water droplets',
    learningObjective4: 'Connect to the natural water cycle',
    safetyNote1: 'This is a virtual experiment - no real heat sources used',
    safetyNote2: 'In real experiments, always use proper safety equipment',
    safetyNote3: 'Adult supervision required for real heat experiments',
    flashcardSet: 'Flashcard Set',
    flashcardSetDescription: 'Interactive flashcards for learning',
    gridActivity: 'Grid Activity',
    gridActivityDescription: 'Interactive grid-based learning activity',
    audioBank: 'Audio Bank',
    audioBankDescription: 'Audio resources for auditory learning',
    memoryGame: 'Memory Game',
    memoryGameDescription: 'Interactive memory game to match emojis with words',
    sortingGame: 'Sorting Game',
    sortingGameDescription: 'Interactive sorting game to categorize items',
    zero: 'Zero',
    one: 'One',
    two: 'Two',
    three: 'Three',
    four: 'Four',
    five: 'Five',
    six: 'Six',
    seven: 'Seven',
    eight: 'Eight',
    nine: 'Nine',
    ten: 'Ten',
    // GPF Resource Types
    sortingCanvas: 'Sorting Canvas',
    sortingCanvasDescription: 'Interactive canvas for sorting and classification activities',
    spatialCanvas: 'Spatial Canvas',
    spatialCanvasDescription: 'Interactive canvas for spatial positioning and topology',
    topologyCanvas: 'Topology Canvas',
    topologyCanvasDescription: 'Interactive canvas for inside/outside topology exercises',
    patternMaker: 'Pattern Maker',
    patternMakerDescription: 'Interactive tool for creating and continuing patterns',
    drawingBoard: 'Drawing Board',
    drawingBoardDescription: 'Interactive drawing canvas with tools and templates',
    objectManipulator: 'Object Manipulator',
    objectManipulatorDescription: 'Interactive tool for object manipulation and transformation',
    shapeRecognition: 'Shape Recognition',
    shapeRecognitionDescription: 'Interactive activity to recognize and name geometric shapes'
  },

  // UI Component Types
  uiComponentTypes: {
    display: 'Display',
    displayDescription: 'Show a resource for viewing only',
    manipulative: 'Manipulative',
    manipulativeDescription: 'Interactive resource for hands-on learning',
    timer: 'Timer',
    timerDescription: 'Countdown timer component',
    quiz: 'Quiz',
    quizDescription: 'Assessment component',
    activity: 'Activity',
    activityDescription: 'Interactive learning activity',
    assessment: 'Assessment',
    assessmentDescription: 'Student assessment component',
    feedback: 'Feedback',
    feedbackDescription: 'Student feedback component'
  },

  // Resource Configuration Panel
  resourceConfigurationPanel: {
    configure: 'Configure',
    id: 'ID'
  },

  // Resources Panel
  resourcesPanel: {
    resources: 'Resources',
    resourcesForStep: 'resources for this step',
    noResources: 'No Resources',
    noResourcesDescription: 'No resources are attached to this step.',
    unsupportedResourceType: 'Unsupported resource type',
    customConfig: 'Custom Config',
    expand: 'Expand',
    collapse: 'Collapse',
    minimize: 'Minimize',
    maximize: 'Maximize',
    close: 'Close',
    scrollToTop: 'Scroll to top'
  },

  // Quiz Configuration
  quizConfiguration: {
    numberOfItems: 'Number of Items',
    shuffleQuestions: 'Shuffle Questions',
    randomizeQuestionOrder: 'Randomize question order',
    quizQuestions: 'Quiz Questions',
    addSampleQuestions: 'Add Sample Questions',
    clearAll: 'Clear All',
    confirmRemoveAllQuestions: 'Are you sure you want to remove all questions?',
    question: 'Question',
    moveUp: 'Move up',
    moveDown: 'Move down',
    deleteQuestion: 'Delete question',
    questionPrompt: 'Question Prompt',
    enterQuestionPrompt: 'Enter question prompt',
    correctAnswer: 'Correct Answer',
    enterCorrectAnswer: 'Enter correct answer',
    answerChoices: 'Answer Choices (comma-separated)',
    choicesPlaceholder: '1, 2, 3, 4, 5',
    choices: 'choices',
    countObjects: 'Count Objects',
    addChoice: 'Add Choice',
    removeChoice: 'Remove Choice',
    answerNotInChoices: 'Answer not in choices!',
    interactiveResource: 'Interactive Resource',
    resourceType: 'Resource Type',
    objectsCount: 'Objects Count',
    layout: 'Layout',
    randomClustered: 'Random Clustered',
    twoGroups: 'Two Groups',
    linear: 'Linear',
    randomize: 'Randomize',
    randomizeObjectPositions: 'Randomize object positions',
    frameValue: 'Frame Value',
    rows: 'Rows',
    columns: 'Columns',
    minValue: 'Minimum Value',
    maxValue: 'Maximum Value',
    tickEvery: 'Tick Every',
    markPosition: 'Mark Position',
    bank: 'Bank (comma-separated)',
    bankPlaceholder: '0, 1, 2, 3, 4, 5',
    mode: 'Mode',
    readAndSelect: 'Read and Select',
    dragAndDrop: 'Drag and Drop',
    clickToFill: 'Click to Fill',
    autoFlip: 'Auto Flip',
    cards: 'Cards (comma-separated)',
    cardsPlaceholder: 'A, B, C, D, E',
    autoFlipCards: 'Auto flip cards',
    addResource: 'Add Resource',
    removeResource: 'Remove Resource',
    addQuestion: 'Add Question',
    addNewQuestion: 'Add New Question',
    includeInteractiveResource: 'Include Interactive Resource',
    addInteractiveComponent: 'Add interactive component (e.g., count objects)',
    quickAdd: 'Quick Add',
    enterChoices: 'Enter choices (comma-separated)',
    correctAnswerMustBeOneOfTheChoices: 'Correct answer must be one of the choices',
    howManyObjectsDoYouSee: 'How many objects do you see?',
    whatNumberComesAfter9: 'What number comes after 9?',
    whatIs5Plus3: 'What is 5 + 3?'
  },

  // Number Line Component
  numberLine: {
    numberLine: 'Number Line',
    current: 'Current',
    range: 'Range',
    zoom: 'Zoom',
    showingEvery: 'showing every',
    number: 'number',
    numbers: 'numbers'
  },

  // Ten Frame Component
  tenFrame: {
    tenFrame: 'Ten Frame',
    count: 'Count',
    preset: 'Preset'
  },

  // Count Objects Component
      countObjects: {
      countObjects: 'Count Objects',
      counted: 'Counted'
    },

  // Audio Bank Component
  audioBank: {
    audioBank: 'Audio Bank',
    wordsAvailable: 'words available',
    playing: 'Playing...',
    clickToPlay: 'Click to play',
    playAll: 'Play All',
    stop: 'Stop',
    clear: 'Clear',
    speechSynthesisNotSupported: 'Speech synthesis is not supported in this browser. Audio playback will not work.'
  },

  // Simulation Component
  simulation: {
    virtualLabSimulation: 'Virtual Lab Simulation',
    interactiveScienceExperiment: 'Interactive science experiment',
    experimentComponents: 'Experiment Components',
    experimentInProgress: 'Experiment in progress...',
    temperature: 'Temperature',
    humidity: 'Humidity',
    waterLevel: 'Water Level',
    startExperiment: 'Start Experiment',
    nextStep: 'Next Step',
    reset: 'Reset'
  },

  // Interactive Diagram Component
  interactiveDiagram: {
    interactiveDiagram: 'Interactive Diagram',
    clickOnStagesToLearnMore: 'Click on stages to learn more'
  },

  // Quiz Component
  quiz: {
    quizResults: 'Quiz Results',
    correct: 'Correct',
    perfectScore: 'Perfect score!',
    keepPracticing: 'Keep practicing!',
    quickQuiz: 'Quick Quiz',
    question: 'Question',
    of: 'of'
  },

  // Tracking Dashboard Page
  trackingDashboardPage: {
    trackingDashboard: 'Tracking Dashboard',
    monitorStudentEngagement: 'Monitor student engagement and learning analytics',
    filters: 'Filters',
    refreshData: 'Refresh data',
    lesson: 'Lesson',
    selectALesson: 'Select a lesson',
    untitledLesson: 'Untitled Lesson',
    startDate: 'Start Date',
    endDate: 'End Date',
    noLessonSelected: 'No Lesson Selected',
    selectLessonToViewData: 'Select a lesson from the filters above to view tracking data',
    lessonId: 'Lesson ID',
    export: 'Export',
    exporting: 'Exporting...',
    clearData: 'Clear Data',
    confirmClearData: 'Are you sure you want to clear all tracking data for this lesson? This action cannot be undone.',
    totalStudents: 'Total Students',
    averageTime: 'Average Time',
    averageScore: 'Average Score',
    completionRate: 'Completion Rate',
    recentEvents: 'Recent Events',
    loadingEvents: 'Loading events...',
    noEventsFound: 'No events found for the selected date range',
    student: 'Student',
    unknownTime: 'Unknown time',
    invalidTime: 'Invalid time',
    dataPoints: 'data points',
    trackingDisabled: 'Tracking Disabled',
    enableTrackingMessage: 'Enable tracking in lesson settings to collect student data',
    loading: 'Loading...',
    noLessonsAvailable: 'No Lessons Available',
    createLessonsToTrack: 'Create lessons to start tracking student engagement',
    searchLessons: 'Search lessons...',
    noLessonsFound: 'No lessons found matching your search'
  },

  // Lesson Session
  lessonSession: {
    lessonCompleted: 'Lesson completed! Great job!',
    loadingLesson: 'Loading lesson...',
    hideResources: 'Hide Resources',
    showResources: 'Show Resources',
    resources: 'Resources',
    teacherScript: 'Teacher Script',
    studentActions: 'Student Actions',
    checksForUnderstanding: 'Checks for Understanding',
    lookFor: 'Look for',
    commonError: 'Common Error',
    sessionControls: 'Session Controls',
    finish: 'Finish',
    step: 'Step',
    of: 'of',
    lessonInformation: 'Lesson Information',
    duration: 'Duration',
    minutes: 'minutes',
    objectives: 'Objectives',
    digitalMaterials: 'Digital Materials',
    physicalMaterials: 'Physical Materials',
    availableAssessments: 'Available Assessments',
    questions: 'questions',
    studentSelected: 'Student Selected',
    selectStudent: 'Select Student',
    clearStudentSelection: 'Clear Student Selection'
  },

  // Student Selector
  studentSelector: {
    currentStudent: 'Current Student',
    noStudentSelected: 'No student selected',
    students: 'Students',
    addStudent: 'Add Student',
    editStudent: 'Edit Student',
    deleteStudent: 'Delete Student',
    updateStudent: 'Update Student',
    addNewStudent: 'Add New Student',
    name: 'Name',
    grade: 'Grade',
    class: 'Class',
    enterName: 'Enter student name',
    enterGrade: 'Enter grade',
    enterClass: 'Enter class',
    cancel: 'Cancel',
    clearSelection: 'Clear Selection',
    noStudents: 'No students available',
    noSearchResults: 'No students match your search',
    confirmDelete: 'Are you sure you want to delete this student?',
    importStudents: 'Import Students',
    exportStudents: 'Export Students',
    import: 'Import',
    export: 'Export',
    importDescription: 'Upload a JSON file containing an array of students. Each student should have a name, and optionally grade and class.',
    fileFormat: 'File Format',
    selectFile: 'Select JSON File',
    importing: 'Importing...',
    searchStudents: 'Search students...',
    lessonFilterActive: 'Lesson Filter Active'
  },

  // Pattern Maker Component
  patternMaker: {
    name: 'Pattern Maker',
    description: 'Pattern and rhythm creator for sequencing exercises',
    question: 'Question or instruction',
    pattern: 'Pattern to reproduce',
    options: 'Available elements',
    allowInteraction: 'Allow interaction',
    showHint: 'Show hints',
    maxLength: 'Maximum length',
    addPatternItem: 'Add to pattern',
    addOptionItem: 'Add to options',
    removeItem: 'Remove element',
    playPattern: 'View model',
    validatePattern: 'Validate pattern',
    resetPattern: 'Restart',
    patternCompleted: 'Pattern completed',
    patternIncorrect: 'Pattern incorrect',
    continuePattern: 'Continue the pattern',
    elementsPlaced: 'Elements placed',
    patternsCompleted: 'Patterns completed',
    removeLastElement: 'Remove last element',
    availableElements: 'Available elements',
    yourPattern: 'Your pattern',
    modelPattern: 'Model to reproduce',
    quickPatterns: 'Quick patterns',
    redBlue: 'Red-Blue',
    stars: 'Stars',
    fruits: 'Fruits',
    colors: 'Colors',
    quickOptions: 'Quick options',
    perfect: 'Perfect! You have reproduced the pattern correctly!',
    good: 'Good! Continue!',
    tryAgain: 'Try again!',
    startPlacing: 'Start by placing an element!',
    continue: 'Continue! Missing elements.',
    allElementsPlaced: 'All elements are placed! Click "Validate" to check.',
    noElementsPlaced: 'No elements placed to validate',
    tip: 'Tip: Look at the model and reproduce the same pattern!'
  },

  // Shape Recognition Component
  shapeRecognition: {
    name: 'Shape Recognition',
    description: 'Interactive activity to recognize and name geometric shapes',
    instructions: 'Instructions',
    shapes: 'Shapes',
    shapeName: 'Shape name',
    shapeDescription: 'Description',
    properties: 'Properties',
    addShape: 'Add shape',
    removeShape: 'Remove shape',
    addProperty: 'Add property',
    removeProperty: 'Remove property',
    showHints: 'Show hints',
    allowCorrections: 'Allow corrections',
    difficultyLevel: 'Difficulty level',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    whatShape: 'What is this shape called?',
    validate: 'Validate',
    showAnswer: 'Show answer',
    nextShape: 'Next shape',
    restart: 'Restart',
    congratulations: 'Congratulations!',
    allShapesRecognized: 'You have recognized all shapes!',
    progress: 'Progress',
    shapesRecognized: 'shapes recognized',
    correct: 'Great! It\'s a {shapeName}!',
    incorrect: 'That\'s not quite right. Try again!',
    hint: 'It\'s a {shapeName}!',
    allShapes: 'All shapes',
    commonShapes: 'Common shapes',
    circle: 'Circle',
    square: 'Square',
    triangle: 'Triangle',
    rectangle: 'Rectangle',
    diamond: 'Diamond',
    star: 'Star',
    hexagon: 'Hexagon',
    pentagon: 'Pentagon'
  },

  // Sorting Game Component
  sortingGame: {
    sortingGame: 'Sorting Game',
    sortItemsIntoCategories: 'Sort items into the correct categories',
    dragItemsToCategories: 'Drag items to categories',
    startGame: 'Start Game',
    resetGame: 'Reset Game',
    validateSorting: 'Validate Sorting',
    gameCompleted: 'Game Completed!',
    correctPlacement: 'Correct placement!',
    incorrectPlacement: 'Incorrect placement',
    tryAgain: 'Try again',
    itemsSorted: 'Items sorted',
    sortedItems: 'Items sorted',
    totalItems: 'Total',
    status: 'Status',
    completed: 'Completed',
    inProgress: 'In Progress',
    sortingCriteria: 'Sorting criteria',
    byCategory: 'By category',
    byColor: 'By color',
    bySize: 'By size',
    changeCriteria: 'Change criteria',
    validationResults: 'Validation results',
    correctItems: 'Correct items',
    correct: 'Correct',
    incorrectItems: 'Incorrect items',
    incorrect: 'Incorrect',
    accuracy: 'Accuracy',
    wellDone: 'Well done!',
    keepTrying: 'Keep trying!',
    perfectScore: 'Perfect score!',
    goodJob: 'Good job!',
    almostThere: 'Almost there!',
    hints: 'Hints',
    showHints: 'Show hints',
    hideHints: 'Hide hints'
  }
};
